import { EVENT_TYPES } from 'consts'
import React from 'react'
import { timeZoneConvert } from 'utils'
import ChartPadder from '../ChartPadder'
import ContinuesChart from './ContinuesChart'
import SpotCheckChart from './SpotCheckChart'

const dataFormatter = (data)=>{
    const {BLOOD_PRESSURE_SYS, BLOOD_PRESSURE_DIA, SPO2, BODY_TEMP, GLUCOSE} = EVENT_TYPES
    const formated = {...data}
    const offsetTime = timeZoneConvert(data.time, 'add')
    formated.time = offsetTime.getTime()
    if(data[BLOOD_PRESSURE_SYS]) formated[BLOOD_PRESSURE_SYS] = `${data[BLOOD_PRESSURE_SYS]}/${data[BLOOD_PRESSURE_DIA]}`
    if(data[SPO2]) formated[SPO2] = `${data[SPO2]}%`
    if(data[BODY_TEMP]) formated[BODY_TEMP] = data[BODY_TEMP]
    if(data[GLUCOSE]) formated[GLUCOSE] = data[GLUCOSE]
    return formated
}

const isSpotCheck = (data) =>{
    return data[EVENT_TYPES.BLOOD_PRESSURE_SYS] || data[EVENT_TYPES.SPO2] || data[EVENT_TYPES.BODY_TEMP] || data[EVENT_TYPES.GLUCOSE]
}

export default function DailyChart({data,dayStr,units,props,configurations}) {
    const configuration = configurations ? configurations : props?.user?.data?.appConfigs?.configuration?.measurements
    const midnightTime = new Date( new Date(dayStr).setHours(0) ).getTime();
    const timeData = data.map(({data})=>dataFormatter(data)).filter(({time})=>new Date(time)<=new Date(midnightTime+24*60*60*1000)) //move time convert to milis to sql?
    const spotChecks= data.filter(({data})=>isSpotCheck(data)).map(({data})=>dataFormatter(data)).filter(({time})=>new Date(time)<=new Date(midnightTime+24*60*60*1000))
    const xLines = [midnightTime,...spotChecks.map(({time})=>time)]
    const xTicks = [0,2,4,6,8,10,12,14,16,18,20,22,24].map(i=>midnightTime+(i*60*60*1000))

    return (
        <>
        { configuration.pulse_rate !=='off' && 
            <ContinuesChart 
                data={timeData}
                name="Pulse Rate"
                dataKey={EVENT_TYPES.PULSE_RATE}
                unit={units?.['Pulse Rate']}
                xTicks={xTicks}
                yTicks={[20,40,60,80,100,120,140,160,180]}
                xLines={xLines}
                strokeColor="#418FCB"
                gridColor="#418FCB22" /> 
        }
        
        <ChartPadder 
            height={26}
            xTicks={xTicks} 
            xLines={xLines} />
             { configuration.respiratory_rate !=='off' && 
                <ContinuesChart 
                    data={timeData}
                    name="Respiratory Rate"
                    unit={units?.['Respiratory Rate']}
                    dataKey={EVENT_TYPES.RESPIRATORY_RATE}
                    xTicks={xTicks}
                    yTicks={[10,20,30,40]} 
                    xLines={xLines} 
                    strokeColor="#F17927"
                    gridColor="#CD7A424D"
                    gridOpacity ="0.5" />
            } 
        <SpotCheckChart 
            data={spotChecks}
            xTicks={xTicks}
            name="Blood Pressure" 
            unit={units?.['Blood Pressure']}
            dataKey={EVENT_TYPES.BLOOD_PRESSURE_SYS}
            xLines={xLines} 
            height={60} />
        <SpotCheckChart 
            data={spotChecks} 
            xTicks={xTicks}
            name="SpO2" 
            dataKey={EVENT_TYPES.SPO2}
            xLines={xLines} 
            height={60} />
        <SpotCheckChart 
            data={spotChecks} 
            xTicks={xTicks}
            name="Body Temp"
            unit={units?.['Body Temp']}
            dataKey={EVENT_TYPES.BODY_TEMP} 
            xLines={xLines} 
            height={60}
            />
         <SpotCheckChart 
            data={spotChecks} 
            xTicks={xTicks}
            name="Glucose" 
            unit={units?.['Glucose']}
            dataKey={EVENT_TYPES.GLUCOSE} 
            xLines={xLines} 
            height={90}
            showX={true} 
            />
        </>
    )
}
